import { endpoints, request } from '!core/api';

export const bannerContentsServices = {
  getBannerContents: ({ bannerCode }) =>
    request.get(endpoints.chnn(`wsbGetBannerContents?bannCode=${bannerCode}`)),
  getContentBody: ({ contSeq }) =>
    request.get(endpoints.chnn(`wsbGetContentBody?contSeq=${contSeq}`)),
};
